module.exports = __webpack_public_path__ + "img/noAuth.6df38666.png";